import { render } from "./user-management.vue?vue&type=template&id=417c5fc4"
import script from "./user-management.vue?vue&type=script&lang=js"
export * from "./user-management.vue?vue&type=script&lang=js"
script.render = render

export default script